export default "__VITE_ASSET__BRq0SoUG__"